import { FormField, FormRenderTypes } from "../Shared/Components/FormRenderer";

export const offerOptionTypeFields: FormField[] = [
	{
		name: "name",
		label: "Nazwa typu opcji",
		type: FormRenderTypes.input,
		value: "",
		group: "Podstawowe",
	},
	{
		name: "offerOptionsValues",
		label: "Wartości opcji",
		type: FormRenderTypes.dynamicList,
		group: "Wartości",
		itemFields: [
			{ name: "value", label: "Wartość", type: FormRenderTypes.input },
			{ name: "shortName", label: "Skrót", type: FormRenderTypes.input },
		],
	},
];
